import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import TemplateDuplicationButtonWithRedux from 'SelfServeBuilder/TemplateDuplicationButton';
import { SelfServeBuilderSidePanelTypes } from 'SelfServeBuilderSidePanel';
import OrganizeAndPrepareToSendButtons from './OrganizeAndPrepareToSendButtons';

class SelfServeBuilderToolbarButtons extends React.Component {
  static handleDuplicationFailure() {
    window.location.assign(`/self-serve-responses?documentType=${window.CurrentDocument.type}&error=template-duplication-failed`);
  }

  render() {
    const {
      documentType,
      isPreviewMode,
      isShared,
      publishedAt,
    } = this.props;

    const panelState = this.props[SelfServeBuilderSidePanelTypes.POST_BUILDER];
    const additionalButtonClassName = classnames({
      'shift-left': panelState.isOpen,
    });

    if ((isShared || publishedAt) && !isPreviewMode) {
      return (
        <React.Fragment>
          <span className="self-serve-duplicate-button-text">Need to make edits?</span>
          <TemplateDuplicationButtonWithRedux
            additionalClassNames={additionalButtonClassName}
            documentType={documentType}
            errorCallback={SelfServeBuilderToolbarButtons.handleDuplicationFailure}
          />
        </React.Fragment>
      );
    }

    return (
      <OrganizeAndPrepareToSendButtons />
    );
  }
}

SelfServeBuilderToolbarButtons.propTypes = {
  documentType: PropTypes.string.isRequired,
  isPreviewMode: PropTypes.bool,
  isShared: PropTypes.bool.isRequired,
  publishedAt: PropTypes.string,
};

SelfServeBuilderToolbarButtons.defaultProps = {
  isPreviewMode: false,
  publishedAt: '',
};

const mapStateToProps = ({ SelfServeBuilderReducer, SelfServeBuilderSidePanelHandler }) => ({
  documentType: SelfServeBuilderReducer.documentType,
  isShared: SelfServeBuilderReducer.isShared,
  publishedAt: SelfServeBuilderReducer.publishedAt,
  ...SelfServeBuilderSidePanelHandler,
});

const SelfServeBuilderToolbarButtonsWithRedux = connect(
  mapStateToProps,
)(SelfServeBuilderToolbarButtons);

export default SelfServeBuilderToolbarButtonsWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/SelfServeBuilderToolbar/SelfServeBuilderToolbarButtons.jsx